import { Component, EventEmitter, Output, inject } from '@angular/core';
import { OutboundFax } from '../../../core/models/outbound-fax.model';
import { OutboundFaxesResult, OutboundFaxesService } from '../../../core/services/outbound-faxes.service';
import { OutboundFaxStatus } from '../../../core/enums/outbound-fax-status.enum';
import { InboundFaxStatus } from '../../../core/enums/inbound-fax-status.enum';
import { sortBy } from 'lodash-es';
import { keyedStatusOptions as keyedProviderOfficeStatusOptions } from 'app/core/options/provider-office-status.opts';
import { OutboundFaxSearchFormComponent } from '../outbound-fax-search-form/outbound-fax-search-form.component';
import { NgClass, TitleCasePipe, DatePipe } from '@angular/common';
import { PatientNameComponent } from '../../../shared/components/patient-name/patient-name.component';
import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { PhoneNumberComponent } from '../../../shared/components/phone-number/phone-number.component';
import { OutboundFaxTemplateComponent } from '../../../shared/components/outbound-fax-template/outbound-fax-template.component';
import { RouterLink } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-outbound-fax-selector',
    templateUrl: './outbound-fax-selector.component.html',
    styleUrls: ['./outbound-fax-selector.component.scss'],
    imports: [OutboundFaxSearchFormComponent,
              NgClass,
              PatientNameComponent,
              PrescriberNameComponent,
              PhoneNumberComponent,
              OutboundFaxTemplateComponent,
              RouterLink,
              MatProgressSpinner,
              TitleCasePipe,
              DatePipe]
})
export class OutboundFaxSelectorComponent {
  private outboundFaxesService = inject(OutboundFaxesService);

  hasQueried = false;
  hasResults = false;
  refreshing = false;
  outboundFaxes: OutboundFax[] = [];
  inboundFaxStatuses = InboundFaxStatus;
  outboundFaxStatuses = OutboundFaxStatus;
  keyedProviderOfficeStatusOptions = keyedProviderOfficeStatusOptions;

  @Output() public selectionChange = new EventEmitter<OutboundFax>();

  onOutboundFaxChange(outboundFax: OutboundFax) {
    this.selectionChange.emit(outboundFax);
  }

  onSearch(claimIdentifier: string) {
    this.refreshing = true;
    this.outboundFaxesService.getList(claimIdentifier).subscribe((result: OutboundFaxesResult) => {
      this.refreshing = false;
      this.hasQueried = true;
      this.hasResults = result.outboundFaxes && result.outboundFaxes.length > 0;
      this.outboundFaxes = result.outboundFaxes;
    });
  }

  mostRecentInboundFax(outboundFax: OutboundFax) {
    return sortBy(outboundFax.inboundFaxes, [inboundFax => new Date(inboundFax.fileCreatedAt)]).reverse()[0];
  }
}
